var map = {
	"./add_customer.png": 7001,
	"./admin.png": 1836,
	"./cumulativewindows.png": 7041,
	"./dashboard.png": 2857,
	"./defender.png": 7604,
	"./delete.png": 3880,
	"./device_management.png": 8905,
	"./edge.png": 2622,
	"./email.png": 3397,
	"./emailRed.png": 416,
	"./eye.png": 7318,
	"./firefox.png": 9282,
	"./firefox64.png": 8504,
	"./greenAction.png": 8738,
	"./guide.png": 4553,
	"./java.png": 9337,
	"./msxml.png": 6458,
	"./passwdRed.png": 6018,
	"./password.png": 7090,
	"./patch_centre.png": 2829,
	"./policies.png": 1983,
	"./powershell.png": 6090,
	"./redAction.png": 7782,
	"./reports.png": 8892,
	"./software_assets.png": 6208,
	"./tenant_management.png": 2547,
	"./vector_icon.png": 6994,
	"./vulnerability.png": 5871,
	"./windows11.png": 8692,
	"./windows11h2.png": 4246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8573;